import { StoryblokGetLinksResponse } from '@cinch-nx/data-storyblok'
import {
  generateStoreNameWithType,
  generateStoreType,
  StoreType,
} from '@cinch-nx/landing-ui-shared'

type Path = { params: { slug: string } }

export function storeStaticPaths({
  links,
}: {
  links: StoryblokGetLinksResponse['links']
}) {
  const paths: Path[] = []

  for (const linkKey of Object.keys(links)) {
    if (links[linkKey].is_folder) {
      continue
    }

    const slug = links[linkKey].slug.split('/')[1]

    paths.push({ params: { slug } })
  }

  return paths
}

const isClickAndCollect = (storeName: string) => {
  const storeType = generateStoreType(storeName)
  return storeType === StoreType.clickAndCollect
}

export const generateFallbackTitle = (storeName: string) => {
  const cinchStoreText = generateStoreNameWithType(storeName)

  return isClickAndCollect(storeName)
    ? cinchStoreText
    : `${cinchStoreText} | Buy used cars in ${storeName}`
}

export const generateFallbackDescription = (storeName: string) => {
  const storeType = generateStoreType(storeName)

  return isClickAndCollect(storeName)
    ? `Welcome to the cinch ${storeType} in ${storeName}, offering click & collect for cinch vehicles.`
    : `Welcome to the cinch ${storeType} in ${storeName}, offering used cars, part exchange & car viewing. Visit the cinch ${storeType} ${storeName} for faff-free car buying.`
}
